import { LinkTo } from "shared/constants/linkTo";
import { lazy } from 'react';

const ContextViewClear = lazy(() => import('shared/pages/context'));

const contextRoutes = [
    { path: LinkTo.context, exact: true, component: ContextViewClear },
    { path: LinkTo.contextOpa, exact: true, isPrivate: true, component: ContextViewClear },
    { path: LinkTo.contextwithparam, exact: true, component: ContextViewClear },
]

export default contextRoutes;import { LinkTo } from "shared/constants/linkTo";
import { lazy } from 'react';

const ContextViewClear = lazy(() => import('shared/pages/context'));

const contextRoutes = [
    { path: LinkTo.context, exact: true, component: ContextViewClear },
    { path: LinkTo.contextOpa, exact: true, isPrivate: true, component: ContextViewClear },
    { path: LinkTo.contextwithparam, exact: true, component: ContextViewClear },
]

export default contextRoutes;